/* Seitenweites Tracking: internal_click, section_view, link_view, product_interaction.
   Event-Schema, Consent-Regeln und Schalter: snippets/internal-click-tracking.liquid (Liquid-Kommentar, wird nicht ausgeliefert). */
(function () {
  'use strict';
  if (window.__sonsuTrack) return;
  window.__sonsuTrack = 1;

  var cfg = {};
  try {
    var el = document.querySelector('script[data-sonsu-link-map]');
    if (el) cfg = JSON.parse(el.textContent) || {};
  } catch (e) {}
  var site = !!cfg.site;
  var seo = document.querySelector('.seo-landing-text');
  if (!site && !seo) return;
  var article = seo ? (seo.querySelector('.page-width') || seo) : null;
  var artists = cfg.artists || {}, service = {}, pdp = cfg.product || null, shopName = cfg.shop || '';
  if (Array.isArray(artists)) { var o = {}; artists.forEach(function (h) { if (h) o[h] = ''; }); artists = o; }
  (cfg.servicePages || []).forEach(function (h) { if (h) service[h] = 1; });

  var HOSTS = { 'studiosonsu.de': 1, 'www.studiosonsu.de': 1, 'pfun0b-uh.myshopify.com': 1 };
  HOSTS[location.hostname] = 1;

  function allowed() {
    if (typeof window.gtag !== 'function') return false;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && !cp.analyticsProcessingAllowed()) return false;
    } catch (e) {}
    return true;
  }
  function send(name, p) {
    if (!allowed()) return false;
    var q = { transport_type: 'beacon' };
    for (var k in p) if (p[k] !== undefined && p[k] !== null && p[k] !== '') q[k] = p[k];
    try { window.gtag('event', name, q); } catch (e) {}
    return true;
  }
  function idx(list, x) { return [].indexOf.call(list, x) + 1; }

  /* ---------- Section-Typ: Wrapper-Klasse aus dem Section-Schema ("class"), sonst inneres Merkmal ---------- */
  var TYPES = [
    ['.featured-product', 'curators-pick'], ['.product-section', 'main-product'],
    ['.collection-tabs-section', 'collection-tabs'], ['.shopify-section-header', 'header'],
    ['.section-announcement', 'announcement-bar'], ['.footer-section', 'footer'],
    ['.seo-landing-content', 'seo-content'], ['>.collection-product-list', 'main-collection'],
    ['.collection-grid-section', 'collection-grid'], ['>.artist-bio__grid', 'artist-bio'],
    ['.rich-text-section', 'rich-text'], ['>.brief-browse', 'brief-browse'],
    ['>.merkliste-section', 'merkliste'], ['.popular-products-section', 'popular-products'],
    ['.section-product-recommendations', 'product-recommendations'], ['.recently-viewed-section', 'recently-viewed'],
    ['.hero-banner-section', 'hero-banner'], ['.image-banner-section', 'image-banner'],
    ['.social-media-collage-section', 'instagram'], ['.collection-banner-section', 'collection-banner'],
    ['.section-main-article', 'main-article'], ['.section-main-blog', 'main-blog'],
    ['.section-list-collections', 'list-collections'], ['.page-section', 'page'],
    ['.products-grid-section', 'products-grid'], ['.product-slider-section', 'product-slider'],
    ['.cards-grid-section', 'grid-banner'], ['.multicolumn-section', 'multicolumn'],
    ['.section-events-list', 'events-list'], ['.collapsible-content-section', 'collapsible-content'],
    ['.blockquote-section', 'blockquote'], ['.slideshow-section', 'slideshow'],
    ['.video-banner-section', 'video-banner'], ['.section-blog-post', 'blog-post'],
    ['.contact-section', 'contact-form'], ['.section-cart-items', 'cart-items'],
    ['.product-markers-section', 'product-markers'], ['.about-story-section', 'about-story']
  ];
  var mainEl = document.getElementById('MainContent') || document.querySelector('main');
  function secInfo(s) {
    if (s.__si) return s.__si;
    var t = '', i;
    for (i = 0; i < TYPES.length && !t; i++) {
      var sel = TYPES[i][0];
      if (sel.charAt(0) === '>' ? s.querySelector(sel.slice(1)) : s.matches(sel)) t = TYPES[i][1];
    }
    if (!t) { // Fallback: Section-Key ohne Zufallssuffix
      var key = (s.id.split('__')[1] || '');
      t = /^[0-9a-f]{8}-/.test(key) ? 'section' : key.replace(/_[A-Za-z0-9]{6}$/, '').replace(/_/g, '-');
    }
    return (s.__si = { section_type: t, section_index: mainEl && mainEl.contains(s) ? idx(mainEl.querySelectorAll('.shopify-section'), s) : 0 });
  }

  /* ---------- Block und Karte ---------- */
  var BLOCK = '.collection-tabs_card-item, .static-footer-menu__accordion, .seo-grid-section';
  var CARDS = ['[data-product]', '.seo-grid-card', '.collection-card', '.article-card'];
  function cardInfo(a, s, p) {
    var blk = a.closest(BLOCK);
    if (blk && s.contains(blk)) p.block_index = idx(s.querySelectorAll(BLOCK), blk); else blk = null;
    var card = a.closest(CARDS.join(','));
    if (card && s.contains(card)) {
      var sl = card.closest('[data-swiper-slide-index]');
      if (sl && s.contains(sl)) { p.card_position = +sl.getAttribute('data-swiper-slide-index') + 1; return; }
      for (var i = 0; i < CARDS.length; i++) if (card.matches(CARDS[i])) { p.card_position = idx((blk || s).querySelectorAll(CARDS[i]), card); return; }
    }
    var li = a.closest('li');
    if (!li || !s.contains(li)) return;
    p.card_position = idx(li.parentElement.children, li);
    var top = li, up;
    while ((up = top.parentElement && top.parentElement.closest('li')) && s.contains(up)) top = up;
    if (!blk && top !== li) p.block_index = idx(top.parentElement.children, top);
  }

  /* ---------- Ziel ---------- */
  function internalUrl(a) {
    var href = a.getAttribute('href');
    if (!href || /^(mailto:|tel:|javascript:)/i.test(href)) return null;
    var u;
    try { u = new URL(href, location.href); } catch (e) { return null; }
    if (!/^https?:$/.test(u.protocol) || !HOSTS[u.hostname]) return null;
    return u;
  }
  function samePageAnchor(a, u) {
    return a.getAttribute('href').charAt(0) === '#' || (u.pathname === location.pathname && !!u.hash);
  }
  function cleanPath(u) { return u.pathname.replace(/^\/en(?=\/)/, ''); }
  function targetTypeOf(u) {
    var path = cleanPath(u), m;
    if (/^\/(collections\/[^/]+\/)?products\//.test(path)) return 'product';
    if ((m = path.match(/^\/collections\/([^/]+)\/?$/))) return artists[m[1]] !== undefined ? 'artist-page' : 'collection';
    if ((m = path.match(/^\/pages\/([^/]+)\/?$/))) return service[m[1]] ? 'other' : 'seo-page';
    if (/^\/blogs\//.test(path)) return 'blog';
    return 'other';
  }
  function artistOfHandle(h) {
    if (pdp && pdp.handle === h) return pdp.vendor;
    var best = '';
    for (var k in artists) if (h.indexOf(k + '-') === 0 && k.length > best.length) best = k;
    return best ? artists[best] : '';
  }
  function artistOf(a, u, type) {
    var path = cleanPath(u), v = '';
    if (type === 'artist-page') v = artists[path.split('/')[2]];
    else if (type === 'product') {
      // Vendor aus der Karte (serverseitig gerendert), sonst PDP-Produkt, sonst Handle-Praefix
      var c = a.closest('[data-product], .seo-grid-card');
      var n = c && (c.querySelector('.card__vendor') || (c.matches('.seo-grid-card') && c.querySelector('p')));
      v = n ? n.textContent.replace(/\s+/g, ' ').trim() : artistOfHandle(path.replace(/^.*\/products\//, '').replace(/\/.*$/, ''));
    }
    return v && v !== shopName ? v : undefined;
  }

  /* ---------- SEO-Artikel: Area, Position, Tiefe (Logik unveraendert) ---------- */
  function isCrosslinkBlock(block) {
    var text = (block.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return false;
    var linkLen = 0;
    block.querySelectorAll('a[href]').forEach(function (a) { linkLen += (a.textContent || '').replace(/\s+/g, ' ').trim().length; });
    return linkLen / text.length >= 0.5 || /\s[|·•]\s/.test(text);
  }
  function areaOf(a, u) {
    if (a.closest('[data-brief-inline], [data-brief-slide]')) return 'brief';
    if (a.closest('.seo-product-grid')) return 'grid';
    if (a.closest('nav') || (u && samePageAnchor(a, u))) return 'toc';
    if (a.closest('figure')) return 'figure';
    var block = a.closest('p, li');
    if (block && article.contains(block)) return isCrosslinkBlock(block) ? 'crosslink' : 'inline';
    if (a.closest('td, th, blockquote, h2, h3, h4, dd, dt')) return 'inline';
    return 'other';
  }
  function positionOf(a, area) {
    var n = 0, pos = 0;
    seo.querySelectorAll('a[href]').forEach(function (x) {
      if (pos) return;
      var xu = internalUrl(x);
      if (!xu || areaOf(x, xu) !== area) return;
      n++;
      if (x === a) pos = n;
    });
    return pos || 1;
  }
  function depthOf(a) {
    var r = article.getBoundingClientRect();
    if (!r.height) return 0;
    return Math.max(0, Math.min(100, Math.round((a.getBoundingClientRect().top - r.top) / r.height * 100)));
  }

  /* ---------- internal_click ---------- */
  var last = null;
  function linkClick(a) {
    var inSeo = !!(seo && seo.contains(a));
    if (!inSeo && !site) return;
    if (!allowed()) return;                                 // kein Consent: nichts senden, nichts puffern
    var u = internalUrl(a);
    if (!u) return;                                         // extern: misst Enhanced Measurement
    var anchor = samePageAnchor(a, u);
    if (anchor && !inSeo) return;                           // Sprungmarken/#-Schalter ausserhalb von Artikeln sind UI
    var now = Date.now();
    if (last && last.a === a && now - last.t < 600) return; // derselbe Klick nur einmal
    last = { a: a, t: now };
    var type = targetTypeOf(u);
    var p = { link_target_type: type, link_target: u.pathname + (anchor ? u.hash : ''), target_artist: artistOf(a, u, type) };
    if (inSeo) {
      p.link_area = areaOf(a, u);
      p.link_position = positionOf(a, p.link_area);
      p.link_depth_pct = depthOf(a);
    }
    var s = a.closest('.shopify-section');
    if (s) {
      var si = secInfo(s);
      p.section_type = si.section_type;
      p.section_index = si.section_index;
      cardInfo(a, s, p);
    }
    send('internal_click', p);
  }

  /* ---------- product_interaction ---------- */
  function product(el, action, value, id) {
    var s = el && el.closest('.shopify-section');
    var p = { action: action, interaction_value: value };
    var inp = s && s.querySelector('input[name="product-id"]');
    p.item_id = String(id || (inp && inp.value) || (pdp && pdp.id) || '');
    if (pdp && String(pdp.id) === p.item_id) p.artist = pdp.vendor;
    else {
      var l = s && s.querySelector('.featured-product__read-more a[href*="/products/"]');
      if (l) p.artist = artistOfHandle(l.getAttribute('href').replace(/^.*\/products\//, '').replace(/[/?#].*$/, ''));
    }
    if (p.artist === shopName) p.artist = '';
    if (s) p.section_type = secInfo(s).section_type;
    return send('product_interaction', p);
  }
  function mediaPos(item) {
    var all = item && item.parentElement ? item.parentElement.querySelectorAll('.product__media-item') : [];
    return idx(all, item) + '/' + all.length;
  }
  function pdpClick(t) {
    var el, v, act;
    if ((el = t.closest('.frame-swatch'))) {
      act = 'frame_select';
      v = el.classList.contains('is-selected') ? 'deselect' : (el.getAttribute('data-type') || 'classic') + ':' + el.getAttribute('data-color-key');
    } else if ((el = t.closest('.frame-type'))) {
      if (el.classList.contains('is-active')) return;
      act = 'frame_select'; v = 'type:' + el.getAttribute('data-type');
    } else if ((el = t.closest('.frame-trigger'))) {
      act = 'frame_select'; v = el.getAttribute('aria-expanded') === 'true' ? 'close' : 'open';
    } else if ((el = t.closest('.product__media-toggle'))) {
      act = 'gallery_zoom'; v = mediaPos(el.closest('.product__media-item'));
    } else if ((el = t.closest('button[name="add"]'))) {
      var fd = el.form && el.form.querySelector('[data-frame-data]');
      act = 'add_to_cart_click'; v = fd && fd.value ? 'with_frame' : 'print_only';
    } else if ((el = t.closest('[data-merken] .merken__btn'))) {
      if (el.closest('[data-merken]').getAttribute('data-logged-in') === 'true') return; // eingeloggt: Ergebnis kommt ueber merkliste:change
      act = 'merken'; v = 'login_prompt';
    } else return;
    product(el, act, v);
  }

  function onClick(e) {
    if (e.type === 'click' ? e.button !== 0 : e.button !== 1) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href]');
    if (a) linkClick(a);
    if (site && e.type === 'click' && e.isTrusted) pdpClick(t);   // isTrusted: Auto-Auswahl per JS zaehlt nicht
  }
  var root = site ? document : seo;
  root.addEventListener('click', onClick, true);
  root.addEventListener('auxclick', onClick, true);
  if (!site) return;

  // Galerie: je neu erreichtem Bild ein Event (hoechstens Bildanzahl - 1 pro Seitenaufruf)
  var seen = { 1: 1 }, gStart = 0, gTimer = 0;
  function galActive(t) {
    var w = t && t.closest && t.closest('.product__media-wrapper');
    var list = w && w.querySelector('.js-media-list');
    if (!list || !list.closest('.shopify-section').matches('.product-section:not(.featured-product)')) return null;
    var slides = list.querySelectorAll('.swiper-slide');
    return { list: list, n: idx(slides, list.querySelector('.swiper-slide-active')), of: slides.length };
  }
  function galDown(e) { var g = galActive(e.target); if (g) gStart = g.n; }
  function galUp(e) {
    var t = e.target;
    if (!galActive(t)) return;
    clearTimeout(gTimer);
    gTimer = setTimeout(function () {
      var g = galActive(t);
      if (!g || g.n < 1 || g.n === gStart || seen[g.n]) return;
      if (product(g.list, 'gallery_swipe', g.n + '/' + g.of)) seen[g.n] = 1;
    }, 450);
  }
  ['pointerdown', 'touchstart'].forEach(function (n) { document.addEventListener(n, galDown, { capture: true, passive: true }); });
  ['pointerup', 'touchend', 'pointercancel'].forEach(function (n) { document.addEventListener(n, galUp, { capture: true, passive: true }); });

  // Anfrage-Formular (vergriffene Editionen): Beginn und Absenden, keine Feldinhalte
  document.addEventListener('focusin', function (e) {
    var f = e.target.closest && e.target.closest('.inquiry-form form');
    if (f && !f.__st && product(f, 'inquiry_click', 'start')) f.__st = 1;
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('.inquiry-form');
    if (f) product(f, 'inquiry_click', 'submit');
  }, true);

  // Merkliste: Ergebnis nach erfolgreichem Speichern/Entfernen (Hook in merkliste.js)
  document.addEventListener('merkliste:change', function (e) {
    var d = e.detail || {};
    product(d.el, d.saved ? 'merken' : 'merken_remove', d.source, d.productId);
  });

  /* ---------- section_view und link_view: ein IntersectionObserver ---------- */
  if (!('IntersectionObserver' in window)) return;
  var th = [], i, watched = [];
  for (i = 0; i <= 20; i++) th.push(i / 20);
  function view(el) {
    if (el.tagName !== 'A') return send('section_view', secInfo(el));
    var u = internalUrl(el), area = areaOf(el, u);
    if (area === 'toc' && tocTotal() > LV_TOC) return 'drop';    // Atlas-Sprungmarken
    var pos = positionOf(el, area);
    if (pos > LV_MAX) return 'drop';
    var type = targetTypeOf(u);
    return send('link_view', {
      link_area: area, link_target_type: type, link_target: u.pathname + (samePageAnchor(el, u) ? u.hash : ''),
      link_position: pos, link_depth_pct: depthOf(el), target_artist: artistOf(el, u, type)
    });
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var s = en.target, h = en.intersectionRect.height, rb = en.rootBounds;
      var ok = en.isIntersecting && h > 0 && (en.intersectionRatio >= 0.5 || (s.tagName !== 'A' && rb && h >= rb.height / 2));
      if (ok && !s.__vt) {
        s.__vt = setTimeout(function () {
          s.__vt = 0;
          var r = document.visibilityState === 'visible' && view(s);
          if (r) { s.__vs = 1; io.unobserve(s); }
        }, 1000);
      } else if (!ok && s.__vt) { clearTimeout(s.__vt); s.__vt = 0; }
    });
  }, { threshold: th });
  function watch(el) { if (!el.__w) { el.__w = 1; watched.push(el); io.observe(el); } }
  [].forEach.call(document.querySelectorAll('.shopify-section'), function (s) {
    if (!s.matches('.shopify-section-group-header-group, .shopify-section-group-overlay-group')) watch(s);
  });

  // link_view nur in SEO-Artikeln; Produkt-Grids laden per JS nach, deshalb neu scannen, wenn sich der Artikel aendert
  var LV_MAX = 30, LV_TOC = 100, tocN = -1, scanT = 0;
  function tocTotal() {
    if (tocN < 0) { tocN = 0; seo.querySelectorAll('a[href]').forEach(function (x) { var xu = internalUrl(x); if (xu && areaOf(x, xu) === 'toc') tocN++; }); }
    return tocN;
  }
  function scan() { seo.querySelectorAll('a[href]').forEach(function (a) { if (internalUrl(a)) watch(a); }); }
  if (seo) {
    scan();
    new MutationObserver(function () { clearTimeout(scanT); scanT = setTimeout(scan, 400); }).observe(seo, { childList: true, subtree: true });
  }

  // Nach der Consent-Entscheidung laedt gtag verzoegert: sichtbare Elemente einmal neu pruefen
  document.addEventListener('visitorConsentCollected', function () {
    var n = 0, w = setInterval(function () {
      if (++n > 20 || allowed()) {
        clearInterval(w);
        watched.forEach(function (el) { if (!el.__vs) { io.unobserve(el); io.observe(el); } });
      }
    }, 500);
  });
})();
